@let nrOfPlannerItemsForTomorrow =
  addTasksForTomorrowService.nrOfPlannerItemsForTomorrow$ | async;

@if (workContextService.isTodayList && nrOfPlannerItemsForTomorrow) {
  <div class="wrap-add-planned">
    <button
      class="add-scheduled"
      (click)="addTasksForTomorrowService.addAllDueTomorrow()"
      color=""
      mat-stroked-button
      tabindex="1"
    >
      <mat-icon>playlist_add</mat-icon>
      {{
        T.WW.ADD_SCHEDULED_FOR_TOMORROW | translate: { nr: nrOfPlannerItemsForTomorrow }
      }}
    </button>
  </div>
}
